import React from "react";
import { Link } from "react-router-dom";
import "./sudanLanding.scss";
import { useLanguage } from "../i18n/LanguageContext";

const ClosingCTA = () => {
   const { t } = useLanguage();
   return (
      <section className="sd-section sd-closing">
         <div className="container">
            <div className="sd-closing-inner">
               <h2>{t("The humanitarian system is changing. Be at the front of it.")}</h2>
               <p>
                  {t(
                     "Sudanese organizations have operated through decades of crisis. It's time the world recognized your capacity, not just your need. KAPorg is your platform to make that case."
                  )}
               </p>
               <div className="sd-closing-cta">
                  <Link to="/auth/registration" className="sd-btn sd-btn-accent">
                     {t("Register for free today →")}
                  </Link>
                  <a href="#accelerator" className="sd-btn sd-btn-ghost-light">
                     {t("Capacity Accelerator Program")}
                  </a>
               </div>
            </div>
         </div>
      </section>
   );
};

export default ClosingCTA;
